import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { generateBreadcrumbSchema } from '../utils/schemaGenerators';

/**
 * Breadcrumbs - Visible breadcrumb navigation with JSON-LD schema
 *
 * @param {Array} items - Array of { name, href } objects
 * @param {string} className - Additional CSS classes
 */
const Breadcrumbs = ({ items = [], className = '' }) => {
  // Always start with Home
  const breadcrumbItems = [
    { name: 'Home', href: '/' },
    ...items
  ];

  // Generate schema for all items
  const schemaItems = breadcrumbItems.map(item => ({
    name: item.name,
    url: item.href
  }));

  const schema = generateBreadcrumbSchema(schemaItems);

  return (
    <>
      {/* JSON-LD Schema */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      {/* Visible Breadcrumbs */}
      <nav
        aria-label="Breadcrumb"
        className={`text-sm text-gray-500 ${className}`}
      >
        <ol className="flex flex-wrap items-center gap-1">
          {breadcrumbItems.map((item, index) => {
            const isLast = index === breadcrumbItems.length - 1;

            return (
              <li key={item.href} className="flex items-center">
                {index > 0 && (
                  <span className="mx-2 text-gray-400">/</span>
                )}

                {isLast ? (
                  <span
                    className="text-gray-700 font-medium"
                    aria-current="page"
                  >
                    {item.name}
                  </span>
                ) : (
                  <Link
                    to={item.href}
                    className="hover:text-blue-600 transition-colors"
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
